import { render, staticRenderFns } from "./NfCoreRnaSeqBrbSeqSetup.vue?vue&type=template&id=367c531e"
import script from "./NfCoreRnaSeqBrbSeqSetup.vue?vue&type=script&lang=ts"
export * from "./NfCoreRnaSeqBrbSeqSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports